import n, { useState as S, useEffect as w } from "react";
import t from "prop-types";
import R from "classnames";
import e from "dayjs";
import { I as T } from "./Icon-ByeAHRM4.es.js";
import { M as v } from "./Modal-QEuhDWbw.es.js";
import { b as E, a as D } from "./propTypes-DVvgo52A.es.js";
import { b as L, a as P } from "./index-DYWWIBK7.es.js";
import { T as O } from "./index-BB-Wk85r.es.js";
import { f as I, t as r } from "./utils-B8CGXZ5v.es.js";
import { s as p } from "./DatePicker.module-CA_9Z_0M.es.js";
import './PresetDatePicker.css';const _ = "Select-common-module__dropdown___Ou-ye", k = {
  dropdown: _
}, x = (f) => {
  const { options: s, selected: l, handleSelect: y, language: h, onSetRange: i } = f, [c, m] = S(0);
  w(() => {
    if (l.length) {
      const a = s[l[0]].startDate, d = s[l[0]].endDate;
      i(a, d);
    }
  }, [l, i, s]);
  const u = s.length, b = (a) => {
    a.key === "ArrowDown" && c < u - 1 ? m(c + 1) : a.key === "ArrowUp" && c > 0 && m(c - 1);
  }, o = [...s].map((a, d) => ({ ...a, index: d }));
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ n.createElement("div", { className: k.dropdown, onKeyDown: b }, /* @__PURE__ */ n.createElement(
      L,
      {
        options: o,
        selected: l,
        onOptionSelect: y,
        selectAllText: "",
        language: h,
        deselectAllText: "",
        selectedTotalText: "",
        onScroll: () => {
        },
        onExpand: () => {
        },
        focusedIdx: c,
        optionLength: u
      }
    ))
  );
};
x.propTypes = {
  options: t.arrayOf(E).isRequired,
  handleSelect: t.func.isRequired,
  selected: t.arrayOf(t.string.isRequired).isRequired,
  onSetRange: t.func.isRequired,
  language: t.string.isRequired
};
const q = ({
  ariaLabel: f,
  ariaLabelledBy: s,
  language: l,
  start: y,
  end: h,
  onSetRange: i,
  options: c
}) => {
  const [m, u] = S([]), b = (o, a) => {
    u([a.toString()]);
  }, g = /* @__PURE__ */ n.createElement(O.Body2, { responsive: !0 }, /* @__PURE__ */ n.createElement("span", { className: p.date }, I(y, h, !1)));
  return /* @__PURE__ */ n.createElement("div", { style: { width: "100%" } }, /* @__PURE__ */ n.createElement(
    v,
    {
      ariaLabel: f,
      ariaLabelledBy: s,
      align: "left",
      floating: !0,
      launcher: (o) => /* @__PURE__ */ n.createElement(
        "div",
        {
          className: R(
            p.launcher,
            o && p.open,
            p.floating
          )
        },
        /* @__PURE__ */ n.createElement(T, { name: "calendar", color: "currentColor", size: 18 }),
        g,
        /* @__PURE__ */ n.createElement(
          P,
          {
            searchIcon: !1,
            dark: !1,
            expanded: o,
            disabled: !1
          }
        )
      ),
      panel: (o) => /* @__PURE__ */ n.createElement(
        x,
        {
          onSetRange: i,
          onClose: () => o(!1),
          options: c,
          selected: m,
          language: l,
          handleSelect: (a, d) => {
            o(!1), b(a, d);
          }
        }
      )
    }
  ));
};
q.propTypes = {
  /** Accessible modal name provided to the user */
  ariaLabel: t.string,
  /** HTML id of alternate label component */
  ariaLabelledBy: t.string,
  /** Default start date that the datepicker should render */
  start: D,
  /** Default end date that the datepicker should render */
  end: D,
  /** The function called when the user sets a date range */
  onSetRange: t.func.isRequired,
  /** Predefined array of start and end dates selectable by the user.
   * Properties of the mobile option prop type:
   *   startDate, endDate, label, value
   */
  options: t.arrayOf(E),
  /** Language used for datepicker options */
  language: t.string
};
q.defaultProps = {
  ariaLabel: null,
  ariaLabelledBy: null,
  options: [
    {
      value: "0",
      label: "Last Month",
      startDate: r(e().subtract(1, "month")),
      endDate: r(e().subtract(1, "month"))
    },
    {
      value: "1",
      label: "Last 3 Months",
      startDate: r(e().subtract(3, "months")),
      endDate: r(e().subtract(1, "month"))
    },
    {
      value: "2",
      label: "Last Quarter",
      startDate: r(
        e().subtract(1, "quarter").startOf("quarter")
      ),
      endDate: r(e().subtract(1, "quarter").endOf("quarter"))
    },
    {
      value: "3",
      label: "Last 12 months",
      startDate: r(e().subtract(12, "months")),
      endDate: r(e().subtract(1, "month"))
    },
    {
      value: "4",
      label: "Last Year",
      startDate: r(e().subtract(1, "year").startOf("year")),
      endDate: r(e().subtract(1, "year").endOf("year"))
    }
  ],
  language: "en",
  start: {
    month: e().month(),
    year: e().year()
  },
  end: {
    month: e().month(),
    year: e().year()
  }
};
export {
  q as P
};
